module.exports = new __parcel__URL__("apply_k_faq_closed_btn_en.24dccf27.webp").toString();